import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TieSelectorComponent } from './tie-selector.component';
import { CloseButtonModule } from '../../_shared/components/close-button/close-button.module';
@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        CloseButtonModule
    ],
    exports: [
        TieSelectorComponent
    ],
    declarations: [
        TieSelectorComponent
    ]
})
export class TieSelectorModule { }
